import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const packageService = {
  getAllPackages: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/packages`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getPackageById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/packages/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createPackage: async (packageData) => {
    const response = await axios.post(
      `${API_BASE_URL}/packages`,
      packageData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updatePackage: async (id, packageData) => {
    const response = await axios.put(
      `${API_BASE_URL}/packages/${id}`,
      packageData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  deletePackage: async (id) => {
    const response = await axios.delete(
      `${API_BASE_URL}/packages/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export default packageService;

